/** Maps keys of numeric model IDs to values of sort indices. Used to decrease sort index lookup time. */
export interface WorkspaceSortOrderMap {
  [key: number]: number;
}

export function computeWorkspaceSortOrderMap<T extends object>(
  sortedWorkspaceItems: ReadonlyArray<T>,
  computeId: (object: T) => number,
): WorkspaceSortOrderMap {
  return sortedWorkspaceItems.reduce<WorkspaceSortOrderMap>((result, object, index) => {
    // Build the object using mutation, since it may be very big for customers like Better.
    // eslint-disable-next-line no-param-reassign
    result[computeId(object)] = index;
    return result;
  }, {});
}
